import {
  FETCH_WFH_ERROR,
  FETCH_WFH_LOADING,
  FETCH_WFH_SUCCESS,
  FETCH_WFH_OPERATIONS_LOADING,
  FETCH_WFH_OPERATIONS_SUCCESS,
  FETCH_WFH_OPERATIONS_ERROR
} from '../Types/wfhTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {},
  operations: [],
  pagination: null
};

const wfhReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_WFH_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_WFH_OPERATIONS_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_WFH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload.data || action.payload,
        pagination: action.payload.pagination || null
      };

    case FETCH_WFH_OPERATIONS_SUCCESS:
      console.log('Reducer updating operations with:', action.payload);
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        operations: action.payload.data || action.payload,
        pagination: action.payload.pagination || null
      };

    case FETCH_WFH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    case FETCH_WFH_OPERATIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    default:
      return { ...state };
  }
};

export default wfhReducer;
